// Pricing data — single source of truth for the /pricing page
export const PACKAGES = [
  {
    id: "minimum",
    name: "Minimum",
    price: 2495,
    priceLabel: "£2,495",
    tagline: "A professional foundation that makes your building firm look credible and easy to contact.",
    features: [
      "Professionally designed multi-page website",
      "Mobile friendly across all devices",
      "Enquiry form",
      "Basic Google search setup",
      "One round of revisions",
    ],
    cta: "Book a Call",
  },
  {
    id: "flagship",
    name: "Flagship",
    price: 4495,
    priceLabel: "£4,495",
    badge: "Most popular",
    highlight: true,
    tagline: "A conversion-focused website that wins better-qualified enquiries and automates the busywork.",
    features: [
      "Everything in Minimum",
      "Custom premium design",
      "Project gallery",
      "Case study pages for your best projects",
      "Stronger local search optimisation",
      "Automatic email replies to new enquiries",
      "Two rounds of revisions",
    ],
    cta: "Book a Call",
  },
  {
    id: "growth",
    name: "Growth",
    price: 7995,
    priceLabel: "£7,995",
    tagline: "A complete digital system to capture, track and manage leads as you scale.",
    features: [
      "Everything in Flagship",
      "Lead dashboard to track & manage enquiries",
      "Free audit-style lead-capture landing page",
      "Booking calendar integration",
      "Advanced search optimisation",
      "Ongoing support after launch",
      "Three rounds of revisions",
    ],
    cta: "Book a Call",
  },
];

export const PLANS = [
  {
    id: "signature",
    name: "Signature",
    price: 4495,
    priceLabel: "£4,495",
    tagline:
      "The complete website for building firms ready to grow — bespoke design, project galleries, quote forms and every tool needed to turn homeowners into enquiries.",
    badge: "Flagship Package",
    highlight: true,
    features: [
      "Fully bespoke, cinematic design",
      "Unlimited pages",
      "Premium scroll animations",
      "Project galleries & case studies",
      "Quote request & booking system",
      "Local SEO structure & area pages",
      "AI Chatbot integration",
      "CRM & API integrations",
      "Google Ads landing pages",
      "CMS integration",
      "Monthly optimisation",
      "Strategy sessions",
      "30 days launch support",
    ],
    cta: "Book a Call",
  },
];

export const CARE_PLAN = {
  title: "Website Care Plan",
  price: 40,
  priceLabel: "£40",
  period: "/month",
  subtitle: "Keep your website fast, secure and always performing.",
  features: [
    "Secure Hosting",
    "SSL Certificate",
    "Daily Backups",
    "Website Updates",
    "Performance Monitoring",
    "Security Monitoring",
    "Minor Content Changes",
    "Priority Support",
  ],
  cta: "Protect My Website",
};

export const ADD_ONS = [
  { name: "Extra Page", price: "£75" },
  { name: "Logo Design", price: "£150" },
  { name: "Google Business Profile Setup", price: "£99" },
  { name: "Booking System", price: "From £150" },
  { name: "Blog Setup", price: "£100" },
  { name: "Copywriting", price: "From £150" },
  { name: "Google Ads Setup", price: "From £300" },
  { name: "Google Ads Management", price: "From £200/month" },
  { name: "AI Chatbot", price: "From £250" },
];

export const PRICING_FAQ = [
  {
    q: "Do you only work with building firms?",
    a: "Yes — I only work with building firms. That focus means I already understand how homeowners choose a builder, what makes them trust a firm, and which pages and features actually generate quote requests — so you're not paying for a generalist to learn your industry.",
  },
  {
    q: "How long does a website take to build?",
    a: "Typical delivery is 3–4 weeks from kick-off to launch, depending on how quickly project photos and content are supplied. You'll receive a clear, week-by-week delivery schedule on our discovery call, plus launch support after go-live.",
  },
  {
    q: "Do you offer payment plans?",
    a: "Yes — every package is split 50/50: 50% deposit to start, 50% on launch. Longer instalment plans (2–4 monthly payments) are available on request if it helps you spread the investment. Just mention it on our call.",
  },
  {
    q: "What if I want to add extras later?",
    a: "Every website is built on a foundation that scales. You can add extra service or area pages, before-and-after galleries, Google Ads landing pages, blog setup, additional integrations or copywriting at any point using the Optional Add-ons — no rebuild required.",
  },
  {
    q: "Do I own the website?",
    a: "100%. You own the domain, hosting account, content, code and all creative assets once the project is complete. Nothing is locked to me — you have full control.",
  },
  {
    q: "Can you redesign my current website?",
    a: "Yes — redesigns are one of my specialities. If your current website looks outdated, loads slowly or isn't generating enquiries, book a discovery call and I'll audit it, identify the issues and rebuild it to a premium standard.",
  },
];
